"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoOptionsMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NoOptionsMessage = function NoOptionsMessage(props) {
  var selectProps = props.selectProps;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.NoOptionsMessage, props, /*#__PURE__*/_react["default"].createElement("span", null, "\u0423 \u043D\u0430\u0441 \u043D\u0435\u0442 \u0442\u0443\u0440\u043E\u0432 \u0438\u0437 ", /*#__PURE__*/_react["default"].createElement(FindValue, null, selectProps.inputValue)));
};

exports.NoOptionsMessage = NoOptionsMessage;

var FindValue = _styledComponents["default"].span.withConfig({
  displayName: "NoOptionsMessage__FindValue",
  componentId: "sc-y2asd-0"
})(["font-weight:500;"]);